import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const SuccessHeader = ({ orderNumber }) => {
  return (
    <motion.div
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="text-center py-8"
    >
      {/* Success Icon */}
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ 
          type: "spring",
          stiffness: 260,
          damping: 20,
          delay: 0.3 
        }}
        className="w-20 h-20 bg-success rounded-full flex items-center justify-center mx-auto mb-6 shadow-warm-lg"
      >
        <Icon name="Check" size={40} color="white" />
      </motion.div>
      {/* Success Message */}
      <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-3">
        Order Confirmed!
      </h1>
      <p className="text-lg text-muted-foreground mb-2">
        Thank you for your order
      </p>
      <p className="text-sm text-muted-foreground">
        Order Number: <span className="font-mono font-semibold text-primary">{orderNumber}</span>
      </p>
    </motion.div>
  );
};

export default SuccessHeader;